import { NgClass, NgFor } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MenuItem, MenuItemCommandEvent } from 'primeng/api';
import { Subscription } from 'rxjs';
import { ApprezzoCommonModule } from '../../../../apprezzoo-common.module';
import { FabService } from './fab.service';

@Component({
  selector: 'app-fab',
  templateUrl: './fab.component.html',
  imports: [NgClass, NgFor, ApprezzoCommonModule],
  styleUrls: ['./fab.component.scss'],
  standalone: true,
})
export class FabComponent implements OnInit, OnDestroy {
  items: MenuItem[] = [];
  private sub!: Subscription;

  constructor(private fabService: FabService) {}

  ngOnInit() {
    this.sub = this.fabService.items$.subscribe((items) => (this.items = items));
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  execute(item: MenuItem, event: MouseEvent) {
    if (typeof item.command === 'function') {
      const commandEvent: MenuItemCommandEvent = {
        originalEvent: event,
        item: item,
      };
      item.command(commandEvent);
    }
  }
}
